"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewOrderChoice = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Styled = __importStar(require("../styles/choice"));
const NewOrderChoice = ({ onSelect, value, isActive = false, i18n }) => {
    return ((0, jsx_runtime_1.jsxs)(Styled.NewOrderChoiceContainer, { onClick: () => onSelect(value), isActive: isActive, children: [(0, jsx_runtime_1.jsx)(Styled.IconOrderPreparationStep, { width: "24px", height: "24px" }), (0, jsx_runtime_1.jsx)(Styled.ChoiceRadio, { value: String(value), children: (0, jsx_runtime_1.jsx)(Styled.RadioLabel, { children: i18n('order_reopening.modal.text.new_order') }) })] }));
};
exports.NewOrderChoice = NewOrderChoice;
